import React, { useState, useEffect, useRef } from 'react';
import './BeneficiaryPpaList.css'; // Create this file for styling
import { AiOutlineVerticalAlignBottom, AiOutlineEye } from 'react-icons/ai';
import { Tooltip, Modal, Box, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getBeneficiaryPPATrail } from '../../helper/Api';
import Spinner from '../Tools/spinner';


const BeneficiaryPpaList = ({ data, columns, initialItemsPerPageOptions, onPageChange, recordsCount, startItem, endItem, currentPage }) => {
    const [loading, setLoading] = useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPageOptions[0]);
    const [sortedData, setSortedData] = useState([...data]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const [hoveredColumn, setHoveredColumn] = useState(null); // Track which column is hovered
    const [openModal, setOpenModal] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState([]);



    useEffect(() => {
        setSortedData([...data]);
    }, [data]);

    // Sorting handler
    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        const sorted = [...sortedData].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
            return 0;
        });
        setSortConfig({ key, direction });
        setSortedData(sorted);
    };


    const handlePageClick = (page) => {
        console.log('current page: ', currentPage);
        console.log('pageClick', page);
        if (onPageChange) {
            onPageChange(page, itemsPerPage); // Call the function passed from the parent
        }
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        if (onPageChange) {
            onPageChange(1, e.target.value); // Call the function passed from the parent
        }
    };

    const downloadPPAFun = async (url, ppa_id) => {
            const link = document.createElement('a');
            link.href = url;
            link.download = `ppa_${ppa_id}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    
    const handleOpenModal = async (rowData) => {
        await fetchPaymentTrail(rowData.ppa_invoice_batch_id, rowData.reimbursement_beneficiary_account_no);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedRowData([]);
    };


    const fetchPaymentTrail = async (ppa_invoice_batch_id, account_no) => {
        try {
            setLoading(true);
            const response = await getBeneficiaryPPATrail({ ppa_invoice_batch_id, account_no });
            if (response && response.data) {
                setLoading(false);
                setSelectedRowData(response.data.result || []);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching payment trail:', error);
        }
    };

    const getPaymentStatus = (payment_mode, flag_success_return) => {
        if (payment_mode === 'online') {
            if (flag_success_return === '1') {
                return { label: 'Success', color: '#d4edda', textColor: '#155724' };
            } else if (flag_success_return === '0') {
                return { label: 'Rejected', color: '#f8d7da', textColor: '#721c24' };
            } else if (flag_success_return === null) {
                return { label: 'Pending', color: '#fff3cd', textColor: '#856404' };
            } else if (flag_success_return === '2') {
                return { label: 'Failed', color: '#f8d7da', textColor: '#721c24' };
            } else if (flag_success_return === '3') {
                return { label: 'On Hold', color: '#f8d7da', textColor: '#856404' };
            } else {
                return { label: 'Pending', color: '#fff3cd', textColor: '#856404' };
            }
        } else {
            return { label: 'Success', color: '#d4edda', textColor: '#155724' };
        }
    }

    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <div className="table-parent-div">
                <table className="table">
                    <thead>
                        <tr>
                            {columns.map((column) => (
                                <th
                                    key={column.accessor}
                                    onClick={() => handleSort(column.accessor)}
                                    onMouseEnter={() => setHoveredColumn(column.accessor)}
                                    onMouseLeave={() => setHoveredColumn(null)}
                                    className="sortable-header"
                                    style={{ width: column.width }}>
                                    {column.Header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, rowIndex) => (
                            <tr key={'s_no_'+rowIndex} >
                                <td key={rowIndex + startItem} className="ellipsis">
                                    <div className="ellipsis">
                                        {rowIndex + startItem}
                                    </div>
                                </td>
                                <td key={'tier_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.department_level}
                                    </div>
                                </td>
                                <td key={'department_code_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.name}
                                    </div>
                                </td>
                                <td key={'ppa_no'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.ppa_no}
                                    </div>
                                </td>
                                <td key={'payment_mode_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.payment_mode}
                                    </div>
                                </td>
                                <td key={'invoice_no_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.invoice_id || row.beneficiary_reimbursement_id || row.salary_id}
                                    </div>
                                </td>
                                <td key={'approval_date_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.l3_approval_datetime}
                                    </div>
                                </td>
                                <td key={'invoice_count_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.invoice_count}
                                    </div>
                                </td>
                                <td key={'account_code_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        
                                    </div>
                                </td>
                                <td key={'beneficiary_name_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.invoice_beneficiary_name || row.reimbursement_beneficiary_name}
                                    </div>
                                </td>
                                <td key={'beneficiary_account_no_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.invoice_beneficiary_account_no || row.reimbursement_beneficiary_account_no}
                                    </div>
                                </td>
                                <td key={'beneficiary_ifsc_code_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.invoice_beneficiary_ifsc_code || row.reimbursement_beneficiary_ifsc_code}
                                    </div>
                                </td>
                                <td key={'sanctioned_amount_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.invoice_sanctioned_amount || row.reimbursement_gross_amount}
                                    </div>
                                </td>
                                <td key={'total_deduction_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.invoice_total_deduction || row.reimbursement_deduction_amount}
                                    </div>
                                </td>
                                <td key={'total_payable_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {row.invoice_total_payable || row.reimbursement_net_amount}
                                    </div>
                                </td>
                                <td key={'total_payable_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        {getPaymentStatus(row.payment_mode, row.flag_success_return) ? (
                                            <span style={{
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                backgroundColor: getPaymentStatus(row.payment_mode, row.flag_success_return).color,
                                                color: getPaymentStatus(row.payment_mode, row.flag_success_return).textColor
                                            }}>
                                                {getPaymentStatus(row.payment_mode, row.flag_success_return).label}
                                            </span>
                                        ) : (
                                            'N/A'
                                        )}
                                    </div>
                                </td>
                                
                                <td key={'url_'+rowIndex} className="ellipsis">
                                    <div className="ellipsis">
                                        <Tooltip title="Download PPA" arrow>
                                            <button type="button" className='btn btn-primary' onClick={ () => downloadPPAFun(row.ppa_url, row.id) }><AiOutlineVerticalAlignBottom /></button>
                                        </Tooltip>
                                        {
                                            row.payment_mode === 'online' && <Tooltip title="View PPA Payment Trail" arrow>
                                            <button className="btn btn-warning" onClick={() => handleOpenModal(row)}><AiOutlineEye /></button>
                                        </Tooltip>
                                        }
                                        
                                    </div>
                                </td>
                            </tr>
                        ))}
                        {data.length === 0 && (
                            <tr>
                                <td colSpan={columns.length} className="no-data">
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="pagination-container">
                {/* Items per page dropdown */}
                <div className="items-per-page">
                    <label>Rows Per Page: </label>
                    <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
                        {initialItemsPerPageOptions.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Pagination information */}
                <div className="pagination-info">
                    {startItem}–{endItem} of {recordsCount}
                    <button
                        onClick={() => handlePageClick(currentPage - 1)}
                        disabled={currentPage === 1 || currentPage < 1}
                        className="pagination__link"
                    >
                        &#8592; {/* Left arrow for Previous */}
                    </button>
                    <button
                        onClick={() => handlePageClick(currentPage + 1)}
                        disabled={endItem === recordsCount}
                        className="pagination__link"
                    >
                        &#8594; {/* Right arrow for Next */}
                    </button>
                </div>
            </div>

            {/* Modal for Payment Trail */}
            <Modal 
                open={openModal} 
                onClose={handleCloseModal}
                aria-labelledby="payment-trail-modal"
            >
                <Box 
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        boxShadow: 24,
                        padding: '24px',
                        maxWidth: '900px',
                        width: '90%',
                        maxHeight: '80vh',
                        overflowY: 'auto'
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                        <h2 id="payment-trail-modal">Payment Trail Details</h2>
                        <Button onClick={handleCloseModal} sx={{ minWidth: 'auto', padding: '0' }}>
                            <CloseIcon />
                        </Button>
                    </Box>
                    
                    {/* Payment Trail Table */}
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ borderBottom: '2px solid #ddd', background: '#000' }}>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Transaction ID</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Date</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Amount</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Status</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedRowData.length > 0 ? (
                                selectedRowData.map((trail, index) => (
                                    <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
                                        <td style={{ padding: '12px' }}>{trail.transaction_reference || 'N/A'}</td>
                                        <td style={{ padding: '12px' }}>{trail.created_at || 'N/A'}</td>
                                        <td style={{ padding: '12px' }}>{trail.amount_paise || 'N/A'}</td>
                                        <td style={{ padding: '12px' }}>
                                            {getPaymentStatus('online', trail.flag_success_return) ? (
                                            <span style={{
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                backgroundColor: getPaymentStatus('online', trail.flag_success_return).color,
                                                color: getPaymentStatus('online', trail.flag_success_return).textColor
                                            }}>
                                                {getPaymentStatus('online', trail.flag_success_return).label}
                                            </span>
                                        ) : (
                                            'N/A'
                                        )}
                                        </td>
                                        <td style={{ padding: '12px' }}>{trail.reason || 'N/A'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ padding: '12px', textAlign: 'center', color: '#999' }}>
                                        No payment trail data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <Box sx={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <Button variant="contained" onClick={handleCloseModal}>
                            Close
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default BeneficiaryPpaList;